import { Flex, Image, Space, Stack } from '@mantine/core';
import { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { LBArtistCard } from '@/features/search/components/artist-card';
import { LoadingResults } from '@/features/search/components/loading-results/LoadingResults';
import { NotFoundResults } from '@/features/search/components/not-found-results/NotFoundResults';
import { useClubSearchPage } from '@/features/search/pages/club-search-page/hooks/useClubSearchPage';
import { PageLoading } from '@/pages/PageLoading';
import { COUNTRY_LIST } from '@/shared/data/country';
import { LBSearchMultiselect } from '@/shared/ui-kit/components';

import logo from '@/../public/logo.svg';

export const ClubSearchPage = () => {
  const {
    state: {
      isLoading,
      setCitizenships,
      citizenships,
      artistsList,
      elementRef,
      originalArtistsList
    },
    functions: { navigate }
  } = useClubSearchPage();

  const filteredCountryList = useMemo(() => {
    if (!originalArtistsList?.length) return [];

    const countrySet = new Set(
      originalArtistsList.flatMap((artist) => artist.citizenships || [])
    );

    return COUNTRY_LIST.filter((country) => countrySet.has(country.label));
  }, [originalArtistsList]);

  const { formatMessage } = useIntl();

  // useEffect(() => {
  //   const savedScroll = sessionStorage.getItem('searchScrollY');
  //   if (savedScroll) {
  //     setTimeout(() => {
  //       window.scrollTo({ top: parseInt(savedScroll, 10), behavior: 'auto' });
  //       sessionStorage.removeItem('searchScrollY');
  //     }, 100); // Delay to wait for render
  //   }
  // }, []);

  useEffect(() => {
    const savedScroll = sessionStorage.getItem('searchScrollY');
    const savedArtistId = sessionStorage.getItem('searchArtistId');

    if (savedScroll) {
      setTimeout(() => {
        window.scrollTo({ top: parseInt(savedScroll, 10), behavior: 'auto' });
        sessionStorage.removeItem('searchScrollY');
      }, 100);
    }

    if (savedArtistId) {
      setTimeout(() => {
        const element = document.querySelector(
          `[data-artist-id="${savedArtistId}"]`
        );
        if (element) {
          (element as HTMLElement).scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
        sessionStorage.removeItem('searchArtistId');
      }, 200);
    }
  }, []);

  if (isLoading) return <PageLoading />;
  return (
    <div>
      <Flex align='end' justify='space-between'>
        <Image src={logo} />
      </Flex>
      <Space h='16' />
      <LBSearchMultiselect
        searchable
        data={filteredCountryList}
        value={citizenships}
        placeholder={formatMessage({
          id: 'form.search.placeholderCitizienship'
        })}
        onChange={(value) => setCitizenships(value)}
      />

      {!artistsList ? (
        <LoadingResults />
      ) : (
        <Stack gap={20} mt={20}>
          {artistsList ? (
            artistsList?.map((item) => (
              <LBArtistCard
                key={item.artistProfileId}
                data={item}
                data-artist-id={item.artistProfileId}
                navigate={() => {
                  sessionStorage.setItem(
                    'searchScrollY',
                    window.scrollY.toString()
                  );
                  sessionStorage.setItem(
                    'searchArtistId',
                    item.artistProfileId.toString()
                  );
                  navigate({
                    to: '/clubOwner/$id/profile-info/$profileId',
                    params: { profileId: item.artistProfileId.toString() }
                  });
                }}
              />
            ))
          ) : (
            <NotFoundResults />
          )}
        </Stack>
      )}
      <div ref={elementRef} />
    </div>
  );
};
